export { default } from './CookieSettings';
